import { ToothCode } from "../api/claims";
import { TOOTH_CODE_MAPPING } from "../constants/constants";

export const getToothNames = (toothCodes: Array<ToothCode>) => {
  const mappedToothNames = [];
  for (const toothCode of toothCodes) {
    let mappedTooth = TOOTH_CODE_MAPPING[(toothCode.substring(0, 2) as ToothCode)];
    if (!mappedTooth) {
      mappedTooth = TOOTH_CODE_MAPPING[toothCode[0] as ToothCode];
    }
    mappedToothNames.push(mappedTooth);
  };
  return mappedToothNames;
};
